export const escapeMethods = {
  uriComponent: (query) => encodeURIComponent(query),
  // sql: (query) => query.replaceAll(/'/g, "''"),
  sql: (query) => query,
  custom: (query, options) => {
    const customOptions = options || {};
    const keys = Object.keys(customOptions);
    let newQuery = query;
    keys.forEach((key) => {
      newQuery = newQuery.replaceAll(key, customOptions[key]);
    });
    return newQuery;
  }
};
